import * as yup from 'yup'

import { i18WithDefault as t } from '@shared/locale'
import { Types } from 'service-api'
import {
  isCheckInTimeEnabled,
  isCheckInTimeRequired,
  isCheckOutTimeEnabled,
  isCheckOutTimeRequired,
} from 'components-ui/src/shared'
import type { TBookingCart } from '@providers/booking/types'

export const arrivalTimesSchema = (reservation: Types.BookingReservationClientDto) => {
  const schema: Record<string, yup.StringSchema> = {}

  if (isCheckInTimeEnabled(reservation.locationBookingConf!)) {
    schema.checkInTime = yup.string().label(t('checkInOutForm.checkIn'))
    if (isCheckInTimeRequired(reservation.locationBookingConf!)) {
      schema.checkInTime = schema.checkInTime.required()
    }
  }
  if (isCheckOutTimeEnabled(reservation.locationBookingConf!)) {
    schema.checkOutTime = yup.string().label(t('checkInOutForm.checkOut'))
    if (isCheckOutTimeRequired(reservation.locationBookingConf!)) {
      schema.checkOutTime = schema.checkOutTime.required()
    }
  }

  return yup.object().shape(schema)
}

export const arrivalTimesInitialValues = (cart: TBookingCart) => ({
  checkInTime: cart?.checkInTime || '',
  checkOutTime: cart?.checkOutTime || '',
})
